// 应用导出类型枚举
const appExportEnum = {
  cos_fbu: [
    { value: 201, label: '谷仓-销售线索' },
    { value: 202, label: '谷仓-线索公海池' },
    { value: 203, label: '谷仓-潜在客户' },
    { value: 204, label: '谷仓-签约客户' },
    { value: 205, label: '谷仓-成交客户' },
    { value: 206, label: '谷仓-客户代码' },
    { value: 207, label: '谷仓-商机管理' },
    { value: 208, label: '谷仓-访客计划' },
    { value: 209, label: '谷仓-跟进记录' },
    { value: 210, label: '谷仓-签到记录' },
    { value: 212, label: '谷仓-签约主体' },
    { value: 213, label: '谷仓-异动反馈情况' },
    { value: 214, label: '谷仓-销售线索-签到地址' },
    { value: 215, label: '谷仓-潜在客户-签到地址' },
    { value: 216, label: '谷仓-签约客户-签到地址' },
    { value: 217, label: '谷仓-成交客户-签到地址' },
    { value: 218, label: '谷仓-销售线索-在售平台' },
    { value: 219, label: '谷仓-潜在客户-在售平台' },
    { value: 220, label: '谷仓-签约客户-在售平台' },
    { value: 221, label: '谷仓-成交客户-在售平台' },
    { value: 222, label: '谷仓-销售线索-需求海外仓' },
    { value: 223, label: '谷仓-潜在客户-需求海外仓' },
    { value: 224, label: '谷仓-签约客户-需求海外仓' },
    { value: 225, label: '谷仓-成交客户-需求海外仓' },
    { value: 226, label: '谷仓-客户公海池' }
  ],
  cos_ofbu: [
    { value: 401, label: '谷仓-销售线索', lang: 'operate.bbrwti' },
    { value: 402, label: '谷仓-线索公海池', lang: 'operate.261dj8' },
    { value: 403, label: '谷仓-潜在客户', lang: 'operate.t0g8xg' },
    { value: 404, label: '谷仓-激活客户', lang: 'operate.cmu3q3' },
    { value: 405, label: '谷仓-成交客户', lang: 'operate.87gbbl' },
    { value: 406, label: '谷仓-客户代码', lang: 'operate.fde7q7' },
    { value: 407, label: '谷仓-商机管理', lang: 'operate.tv7nl3' },
    { value: 408, label: '谷仓-访客计划', lang: 'operate.vklfym' },
    { value: 409, label: '谷仓-跟进记录', lang: 'operate.h8qs6q' },
    // { value: 410, label: '谷仓-签到记录', lang: 'operate.kazftf' }, // 暂无签到记录功能
    { value: 412, label: '谷仓-签约主体', lang: 'operate.71nu0o' },
    { value: 413, label: '谷仓-异动反馈情况', lang: 'operate.61nfTz' }
  ],
  cos_lbu: [
    { value: 301, label: '云途-销售线索' },
    { value: 302, label: '云途-线索公海池' },
    { value: 303, label: '云途-潜在客户' },
    { value: 304, label: '云途-成交客户' },
    { value: 305, label: '云途-商机管理' },
    { value: 306, label: '云途-跟进记录' },
    { value: 307, label: '云途-访客计划' },
    { value: 308, label: '云途-签到记录' },
    { value: 309, label: '云途-主管陪访（共同销售）' },
    { value: 310, label: '云途-销售业绩辅导' },
    { value: 311, label: '云途-销售线索-签到地址' },
    { value: 312, label: '云途-潜在客户-签到地址' },
    { value: 313, label: '云途-成交客户-签到地址' },
    { value: 314, label: '云途-销售线索-在售平台' },
    { value: 315, label: '云途-潜在客户-在售平台' },
    { value: 316, label: '云途-成交客户-在售平台' },
    { value: 317, label: '云途-销售线索-目的地国家' },
    { value: 318, label: '云途-潜在客户-目的地国家' },
    { value: 319, label: '云途-成交客户-目的地国家' },
    { value: 320, label: '云途-销售线索-物流商' },
    { value: 321, label: '云途-潜在客户-物流商' },
    { value: 322, label: '云途-成交客户-物流商' },
    { value: 323, label: '云途-销售线索-货物品类' },
    { value: 324, label: '云途-潜在客户-货物品类' },
    { value: 325, label: '云途-成交客户-货物品类' },
    { value: 326, label: '云途-销售线索-ERP系统' },
    { value: 327, label: '云途-潜在客户-ERP系统' },
    { value: 328, label: '云途-成交客户-ERP系统' },
    { value: 329, label: '云途-销售技能辅导' },
    { value: 330, label: '云途-商机变动情况' },
    { value: 331, label: '云途-销售业绩辅导-关注指标和项目' },
    { value: 332, label: '云途-销售业绩辅导-行动计划' },
    { value: 333, label: '云途-销售业绩辅导-回顾明细' },
    { value: 334, label: '云途-NC客户信息' },
    { value: 335, label: '云途-数据推送日志' }
  ],
  cos_zbu_fbu: [
    { value: 101, label: '市场营销-线索管理' },
    { value: 103, label: '市场营销-合作伙伴管理' },
    { value: 104, label: '市场营销-接口记录' }
  ],
  cos_zbu_lbu: [
    { value: 101, label: '市场营销-线索管理' },
    { value: 103, label: '市场营销-合作伙伴管理' },
    { value: 104, label: '市场营销-接口记录' }
  ]
}

export default function getOption(appid?: string) {
  if (appid) {
    return appExportEnum[appid] || []
  } else {
    const mergedArray = Object.values(appExportEnum).flatMap((item) => item)
    return mergedArray
  }
}
